<template>
<Toast/>
<!-- <Navbar/> -->
<SideBar/>
 <div class="card main-content">
  <div class="progress-spinner" v-if="loadingStatus">
      <ProgressSpinner></ProgressSpinner>
  </div>

    <div class="card flex  justify-content-center">
        <Card class="main-card">
            <template #subtitle>
              <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                <span class="text-xl text-900 font-bold">New ROC</span>
                <span >
                  <Button label="Save" raised icon="pi pi-save" severity="success" @click="handleSave"/>
                </span>
              </div>
              <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                <span>
                  <router-link to="/roc-list" rel="noopener">
                    <Button size="small" icon="pi pi-bars" label="ROC List" raised />
                  </router-link>
                </span>
                <span ></span>
              </div>
              <Divider/>  
            </template>
            
            <template #content>
              <div class="col-12">
                <div class="card flex flex-wrap gap-3 p-fluid">
                    <div class="flex-auto">
                        <label for="tenderName" class="font-bold block mb-2"> Tender </label>
                        <InputText v-model="tenderName" />
                    </div>
                </div>
              </div>
                
              <div class="col-12">
                <div class="card flex flex-wrap p-fluid ">
                  <div class="col-4">
                    <div class="flex-auto">
                        <label for="tenderDate" class="font-bold block mb-2"> Tender Date </label>
                        <Calendar v-model="tenderDate" showIcon dateFormat="dd/mm/yy" inputId="buttondisplay" />
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="flex-auto">
                      <label for="department" class="font-bold block mb-2">Department</label>
                      <Dropdown size="small" v-model="selectedDept" editable :options="departments" optionValue="id" optionLabel="name" placeholder="Select Department" />
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="flex-auto">
                          <label for="rocNo" class="font-bold block mb-2"> ROC No. </label>
                          <InputText v-model="rocNo" />
                    </div>
                  </div>
                </div>
              </div>                
                  
              <div class="card flex flex-wrap p-fluid">
                <div class="col-4">
                  <div class="flex-auto">
                      <label for="rocDate" class="font-bold block mb-2"> ROC Date </label>
                      <Calendar v-model="rocDate" showIcon dateFormat="dd/mm/yy" inputId="buttondisplay" />
                  </div>
                </div>
                
                <div class="col-4">
                  <div class="flex-auto">
                      <label for="validity" class="font-bold block mb-2"> Validity (Years) </label>
                      <InputNumber v-model="validity" showIcon  inputId="integeronly" />
                  </div>
                </div>

              </div>

              <Divider/>
              <h4>Item details:</h4>
                  
                <!-- individual item component -->
                <!-- <ul> -->
                    <RocItem v-for="(item, index) in items" :key="item.itemId" :index="index" :itemId="item.itemId"  :categories="categories.map(a =>a)" :manufacturers="manufacturers.map(b =>b)"  @delete="items.splice(index, 1)" @bind-item="bindData"/>

                <!-- </ul> -->
                <!-- Add items btn -->
                <div class="flex justify-content-end align-items-center" > <Button label="Add item" size="small" raised icon="pi pi-plus" @click="addItem" /> </div>
            </template>
            <template #footer>
                
            </template>
        </Card>
    </div>
 </div>
</template>

<script>
import InputText from 'primevue/inputtext'
// import Navbar from '../header/headerNavbar.vue' 
import Calendar from 'primevue/calendar'
import Card from 'primevue/card'
import Dropdown from 'primevue/dropdown'
// import FileUpload from 'primevue/fileupload'
import InputNumber from 'primevue/inputnumber'
import Toast from 'primevue/toast'
import Button from 'primevue/button'
import Divider from 'primevue/divider'
import RocItem from './rocItem.vue'
import { getCategories, getDepartments, getManufacturers, createRoc } from '../../services/apiService'
import SideBar from '../sidebar/sideBarTwo.vue'
import ProgressSpinner from 'primevue/progressspinner'

export default {
  components:{
    // Navbar,
    SideBar,  
    Card, 
    InputText, 
    Calendar, 
    Dropdown, 
    // FileUpload, 
    InputNumber, 
    Toast, 
    Button, 
    Divider, 
    RocItem, 
    ProgressSpinner,
  },
  data(){
    return{
      tenderName: '',
      tenderDate: '',
      rocNo:'',
      rocDate:'',
      validity: 0,
      selectedDept: null,
      rocDocument:[],
      departments: null,
      categories:null,
      manufacturers: null,
      items: [],
      itemId: 0,
      itemName: null,
      selectedCategory: null,
      itemRate: 0,
      itemBasic:0,
      itemGst2:0,
      itemNewRate:0,
      itemPacking: null,
      itemManufacturer: null,
      installationStatus: 0,
      loadingStatus: false,
    }
  },
  methods:{
    getDepts(){
      getDepartments().then((res)=> 
            {
                this.departments = res.data
            }
            ).catch((error)=>this.showErrorToast(error.response.data));
    },
    getCategory(){
      getCategories().then((res)=> 
            {
                this.categories = res.data
            }
            ).catch((error)=>this.showErrorToast(error.response.data));
    },
    getManufacturer(){
      getManufacturers().then((res)=> 
            {
                this.manufacturers = res.data
            }
            ).catch((error)=>this.showErrorToast(error.response.data));
    },
    addItem(){
      this.items.push({
        itemId: this.itemId++,
        itemName: this.itemName,
        itemRate: this.itemRate,
        itemBasic: this.itemBasic,
        itemGst2: this.itemGst2,
        itemOldGst: 0,
        itemNewRate: this.itemNewRate,
        selectedCategory: this.selectedCategory,
        itemPacking: this.itemPacking,
        itemManufacturer: this.itemManufacturer,
        installationStatus: this.installationStatus,
      });
    },
    bindData(itemId, itemData){
      const item = this.items.find((e) => e.itemId == itemId);
      item.itemName = itemData.itemName;
      item.itemRate = itemData.itemRate;

      item.itemBasic = itemData.itemBasic;
      item.itemGst2 = itemData.itemGst2;
      item.itemNewRate = itemData.itemNewRate;

      item.itemPacking = itemData.itemPacking;
      item.itemManufacturer = itemData.itemManufacturer;
      item.itemSlNo = itemData.itemSlNo;
      item.selectedCategory = itemData.selectedCategory;
      item.installationStatus = itemData.installationStatus;
    },
    showSuccessToast(data){
        this.$toast.add({ severity: 'success', summary: 'Success', detail:data.message, life: 4000 });
    },   
    showErrorToast(error){
            this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 3000 });
    },
    
    handleSave(){

      this.loadingStatus = true
      if(this.tenderName=='' || this.selectedDept=='' || this.rocNo==''){
        this.showErrorToast({'message': 'All fields must be filled!'})
        return
      }
      if(this.validity==0){
        this.showErrorToast({'message': 'Validity cannot be "0"!'})
        return
      }

      const data ={
        tenderName: this.tenderName,
        tenderDate: this.tenderDate.getDate()+'-'+(this.tenderDate.getMonth()+1)+'-'+this.tenderDate.getFullYear(),
        departmentId: this.selectedDept,
        contractNo: this.rocNo,
        contractDate: this.rocDate.getDate()+'-'+(this.rocDate.getMonth()+1)+'-'+this.rocDate.getFullYear(),
        period: this.validity,
        rocDetails: this.items,
      }
  
      createRoc(data).then((res)=> 
            {
              this.showSuccessToast(res.data);
              this.$router.push('roc-list');
              this.loadingStatus = false;
            }
          ).catch((error)=>{this.showErrorToast(error.response.data); this.loadingStatus = false;});
    },
    
  },
  mounted(){
      this.itemId = 0
      this.getDepts()
      this.getCategory()
      this.getManufacturer()
    }

  
}
</script>

<style scoped>

.main-card{
  width: calc(100% - 100px);
  min-width: calc(100% - 40px);
  margin-top: 20px;
}

</style>